export const RECEIVED_SEARCH_RESULTS = "RECEIVED_SEARCH_RESULTS";
